<template>
  <div class="app-content">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.team.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Create -->
    <div class="app-content-create">
      <!-- Filter button -->
      <app-filter-button :active.sync="activeFilter" />

      <!-- Create -->
      <router-link
        v-if="hasPermissionToCreate"
        :to="{ path: '/team/new' }"
      >
        <el-button
          class="app-content-create-button"
          type="primary"
        >
          <app-i18n code="entities.team.new.title" />
        </el-button>
      </router-link>
    </div>
    
    <!-- Filter form -->
    <app-team-list-filter v-if="activeFilter" />

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.team.list.title"></app-i18n>
      </h1>

      <app-team-list-toolbar></app-team-list-toolbar>
      <app-team-list-table></app-team-list-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { TeamPermissions } from '@modules/team/team-permissions';
import TeamListFilter from '@modules/team/components/team-list-filter.vue';
import TeamListTable from '@modules/team/components/team-list-table.vue';
import TeamListToolbar from '@modules/team/components/team-list-toolbar.vue';

export default {
  name: 'app-team-list-page',
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
    }),
    hasPermissionToCreate() {
      return new TeamPermissions(this.currentUser).create;
    },
  },

  data() {
    return {
      activeFilter: false,
    }
  },
  components: {
    [TeamListFilter.name]: TeamListFilter,
    [TeamListTable.name]: TeamListTable,
    [TeamListToolbar.name]: TeamListToolbar,
  },
};
</script>

<style>
</style>
